import { createNoteRequest, fetchNoteRequest, updateNoteRequest, fetchNotesRequest, deleteNoteRequest } from '../api/index'
import { handleErrorRequest } from '../helpers/api'
import { guid } from '../helpers/index'
import _ from 'lodash'
import { createActions, handleActions } from 'redux-actions'

const failMessageIdentity = failMessage => ({ failMessage })

const createdActions = createActions({
  notes: {
    SUBMIT_NOTE_ATTEMPT: null,
    SUBMIT_NOTE_FAILURE: failMessageIdentity,
    SUBMIT_NOTE_SUCCESS: null,
    DELETE_NOTE_ATTEMPT: null,
    DELETE_NOTE_FAILURE: failMessageIdentity,
    DELETE_NOTE_SUCCESS: null,
    FETCH_NOTE_ATTEMPT: null,
    FETCH_NOTE_FAILURE: failMessageIdentity,
    FETCH_NOTE_SUCCESS: null,
    FETCH_NOTES_ATTEMPT: null,
    FETCH_NOTES_FAILURE: failMessageIdentity,
    FETCH_NOTES_SUCCESS: null,
    SET_CURRENT_NOTE: currentNote => ({ currentNote }),
    SET_NOTES: notes => ({ notes }),
    RESET_STATE: null
  }
})

const {
  notes: {
    submitNoteAttempt,
    submitNoteFailure,
    submitNoteSuccess,
    deleteNoteAttempt,
    deleteNoteFailure,
    deleteNoteSuccess,
    fetchNoteAttempt,
    fetchNoteFailure,
    fetchNoteSuccess,
    fetchNotesAttempt,
    fetchNotesFailure,
    fetchNotesSuccess,
    setNotes,
    setCurrentNote,
  }
} = createdActions

const createNoteAsync = ({ dealer_id, contract_id, data }) => (dispatch, getState) => {
  dispatch(submitNoteAttempt());
  let jwt = _.get(getState(), "auth.user.jwt", "");
  let formData = new FormData();
  const { content, images, videos } = data;
  formData.append("note[content]", content);

  if (images.length > 0) {
    images.forEach(function(img) {
      formData.append("note[images][]", img);
    });
  }

  if (videos.length > 0) {
    videos.forEach(function(video) {
      formData.append("note[videos][]", video);
    });
  }

  return createNoteRequest({
    data: formData,
    dealer_id,
    contract_id,
    jwt
  }).then(({ response, error }) => {
    if (response) {
      dispatch(submitNoteSuccess())
      dispatch(createNoteSync(response.data))
      return Promise.resolve(response.data)
    } else {
      dispatch(submitNoteFailure(handleErrorRequest(error)))
      return Promise.reject(error)
    }
  })
}

const createNoteSync = (note) => (dispatch, getState) => {
  const notes = getState().notes.notes || []
  if (!note.id) {
    note.id = guid()
  }
  dispatch(setNotes([...notes, note]))
}

const fetchNote = ({ dealer_id, contract_id, note_id }) => (dispatch, getState) => {
  dispatch(fetchNoteAttempt())
  let jwt = _.get(getState(), 'auth.user.jwt', '')
  return fetchNoteRequest({ note_id, dealer_id, contract_id, jwt }).then(({ response, error }) => {
    if (response) {
      dispatch(fetchNoteSuccess())
      dispatch(setCurrentNote(response.data))
      return Promise.resolve(response.data)
    } else {
      dispatch(fetchNoteFailure(handleErrorRequest(error)))
      return Promise.reject(error)
    }
  })
}

const fetchNotes = ({ dealer_id, contract_id }) => (dispatch, getState) => {
  dispatch(fetchNotesAttempt())
  let jwt = _.get(getState(), 'auth.user.jwt', '')
  return fetchNotesRequest({ dealer_id, contract_id, jwt }).then(({ response, error }) => {
    if (response) {
      dispatch(fetchNotesSuccess())
      dispatch(setNotes(response.data))
      return Promise.resolve(response.data)
    } else {
      dispatch(fetchNotesFailure(handleErrorRequest(error)))
      return Promise.reject(error)
    }
  })
}

const updateNoteAsync = ({ dealer_id, contract_id, note_id, data }) => (dispatch, getState) => {
  dispatch(submitNoteAttempt())
  let jwt = _.get(getState(), 'auth.user.jwt', '')
  return updateNoteRequest({ dealer_id, note_id, contract_id, data: { note: data }, jwt }).then(({ response, error }) => {
    if (response) {
      dispatch(submitNoteSuccess())
      dispatch(setCurrentNote(null))
      dispatch(updateNoteSync(response.data))
      return Promise.resolve(response.data)
    } else {
      dispatch(submitNoteFailure(handleErrorRequest(error)))
      return Promise.reject(error)
    }
  })
}

const updateNoteSync = (note) => (dispatch, getState) => {
  const currentNote = getState().notes.currentNote || {}
  const notes = getState().notes.notes || []
  var index = _.findIndex(notes, { id: currentNote.id })
  notes.splice(index, 1, Object.assign({}, currentNote, note))
  dispatch(setNotes([...notes]))
  dispatch(setCurrentNote(null))
}

const deleteNoteAsync = ({ dealer_id, contract_id, note_id }) => (dispatch, getState) => {
  dispatch(deleteNoteAttempt())
  let jwt = _.get(getState(), 'auth.user.jwt', '')
  return deleteNoteRequest({ dealer_id, note_id, contract_id, jwt }).then(({ response, error }) => {
    if (response) {
      dispatch(deleteNoteSuccess())
      dispatch(deleteNoteSync({ id: note_id }))
    } else {
      dispatch(deleteNoteFailure(handleErrorRequest(error)))
    }
  })
}

const deleteNoteSync = (note) => (dispatch, getState) => {
  const notes = getState().notes.notes || []
  let nextNotes = _.reject(notes, { id: note.id })
  dispatch(setNotes(nextNotes))
}

export const actions = { ...createdActions.notes, createNoteAsync, createNoteSync, updateNoteAsync, updateNoteSync, deleteNoteAsync, deleteNoteSync, fetchNote, fetchNotes }

export const initialState = {
  submittingNote: false,
  failSubmitNote: null,
  successSubmitNote: false,
  fetchingNote: false,
  failFetchNote: null,
  successFetchNote: false,
  currentNote: null,
  fetchingNotes: false,
  failFetchNotes: null,
  successFetchNotes: false,
  notes: []
}

export default handleActions({
  notes: {
    SUBMIT_NOTE_ATTEMPT: (state, action) =>
      ({ ...state, submittingNote: true, failSubmitNote: null, successSubmitNote: false }),
    SUBMIT_NOTE_SUCCESS: (state, action) =>
      ({ ...state, submittingNote: false, failSubmitNote: null, successSubmitNote: true }),
    SUBMIT_NOTE_FAILURE: (state, { payload: { failMessage } }) =>
      ({ ...state, submittingNote: false, failSubmitNote: failMessage, successSubmitNote: false }),
    DELETE_NOTE_ATTEMPT: (state, action) =>
      ({ ...state, submittingNote: true, failSubmitNote: null, successSubmitNote: false }),
    DELETE_NOTE_SUCCESS: (state, action) =>
      ({ ...state, submittingNote: false, failSubmitNote: null, successSubmitNote: true }),
    DELETE_NOTE_FAILURE: (state, { payload: { failMessage } }) =>
      ({ ...state, submittingNote: false, failSubmitNote: failMessage, successSubmitNote: false }),
    FETCH_NOTE_ATTEMPT: (state, action) =>
      ({ ...state, fetchingNote: true, failFetchNote: null, successFetchNote: false }),
    FETCH_NOTE_SUCCESS: (state, action) =>
      ({ ...state, fetchingNote: false, failFetchNote: null, successFetchNote: true }),
    FETCH_NOTE_FAILURE: (state, { payload: { failMessage } }) =>
      ({ ...state, fetchingNote: false, failFetchNote: failMessage, successFetchNote: false }),
    FETCH_NOTES_ATTEMPT: (state, action) =>
      ({ ...state, fetchingNotes: true, failFetchNotes: null, successFetchNotes: false }),
    FETCH_NOTES_SUCCESS: (state, action) =>
      ({ ...state, fetchingNotes: false, failFetchNotes: null, successFetchNotes: true }),
    FETCH_NOTES_FAILURE: (state, { payload: { failMessage } }) =>
      ({ ...state, fetchingNotes: false, failFetchNotes: failMessage, successFetchNotes: false }),
    SET_CURRENT_NOTE: (state, { payload: { currentNote } }) =>
      ({ ...state, currentNote }),
    SET_NOTES: (state, { payload: { notes } }) =>
      ({ ...state, notes }),
    RESET_STATE: (state, action) =>
      ({ ...state, ...initialState, ...{ notes: state.notes, currentNote: state.currentNote } })
  }
}, initialState)